import React from 'react';
import '../styles/Simulador.css';

const TestResults = () => {
  const detalles = Array.from({ length: 100 }, (_, i) => {
    const estados = ['Correcta', 'Incorrecta', 'Omitida'];
    const estado = estados[i % 3];
    return {
      pregunta: `¿Pregunta de ejemplo número ${i + 1} para probar el layout del simulador y ver cómo se ve el texto cuando es largo?`,
      respuestaSeleccionada: estado === 'Omitida' ? 'No respondida' : `Respuesta del usuario para la pregunta ${i + 1}`,
      respuestaCorrecta: `Respuesta correcta para la pregunta ${i + 1}`,
      estado
    };
  });
  const score = 33;
  const correctas = 33;
  const incorrectas = 33;
  const omitidas = 34;
  const questions = detalles;

  return (
    <div style={{ padding: '2rem', maxWidth: '100%' }}>
      <div className="results-container">
        <h2>¡Simulador finalizado!</h2>
        <div className="results-header">
          <div className="results-score">Puntaje: {score} / {questions.length}</div>
          <div className="results-stats">
            <span className="stat correct">Correctas: {correctas}</span>
            <span className="stat incorrect">Incorrectas: {incorrectas}</span>
            <span className="stat omitted">Omitidas: {omitidas}</span>
          </div>
        </div>
        <h3>Detalle por pregunta:</h3>
        <div className="results-list">
          {detalles.map((d, idx) => (
            <div className="result-card" key={idx}>
              <div className="result-question"><b>Pregunta {idx + 1}:</b> {d.pregunta}</div>
              <div className="result-user-answer">Tu respuesta: <span className={d.estado === 'Correcta' ? 'correct' : d.estado === 'Incorrecta' ? 'incorrect' : 'omitted'}>{d.respuestaSeleccionada}</span></div>
              <div className="result-correct-answer">Respuesta correcta: <span className="correct">{d.respuestaCorrecta}</span></div>
              <div className="result-status">Estado: <b className={d.estado === 'Correcta' ? 'correct' : d.estado === 'Incorrecta' ? 'incorrect' : 'omitted'}>{d.estado}</b></div>
            </div>
          ))}
        </div>
        <button className="finish-button" onClick={() => window.history.back()}>Volver al inicio del simulador</button>
      </div>
    </div>
  );
};

export default TestResults;
